import _ from 'lodash';
import { OrderItem } from '../hooks/useGetProduct/types';
import { REGIONS } from '../constants';

export const formatToTwoDecimalPlaces = (value: number): string => {
  return (Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2);
};

export const convertPrice = (price: number, multiplier: number): number => price * multiplier;

export const getListPrice = (product: OrderItem, region?: string): string => {
  const listPrice = region === REGIONS.AUSTRALIA ? product.listPrice : product.listPriceWithoutTax;
  return formatToTwoDecimalPlaces(listPrice);
};

export const getDiscountPrice = (product: OrderItem, region?: string): string => {
  const discountPrice = region === REGIONS.AUSTRALIA ? product.totalPrice : product.priceWithoutTax;
  return formatToTwoDecimalPlaces(discountPrice);
};

export const getItemPrice = (item : OrderItem, isTaxExcluded: boolean) : number => {
  const originalPrice = isTaxExcluded ? item.listPriceWithoutTax : item.listPrice;
  return originalPrice - item.discountAmount;
};

export const getProductTotalPrice = (productItems: OrderItem[]): number => (
  _.sumBy(productItems, (item) => getItemPrice(item, false))
);

export const getTagPrice =
    (productItems: OrderItem[], promoCode?: string, region?: string): string => (
      promoCode ?
        getDiscountPrice(productItems[0], region) :
        getListPrice(productItems[0], region)
    );
